"use strict";
/**
 * User auth routes
 */
/* tslint:disable */
module.exports = [
    {
        path: '/login',
        component: function () { return import(/* webpackChunkName: 'user-auth' */ 'Views/UserAuth/Login/Login.vue'); },
        meta: {
            requiresAuth: false,
            title: 'Login',
        },
    },
    {
        path: '/forgot-password',
        component: function () { return import(/* webpackChunkName: 'user-auth' */ 'Views/UserAuth/ForgotPassword/ForgotPassword.vue'); },
        meta: {
            requiresAuth: false,
            title: 'Reset Password',
        },
    },
    {
        path: '/forgot-password/:token',
        component: function () { return import(/* webpackChunkName: 'user-auth' */ 'Views/UserAuth/ResetPassword/ResetPassword.vue'); },
        meta: {
            requiresAuth: false,
            title: 'Reset Password',
        },
    },
    {
        path: '/new-password',
        component: function () { return import(/* webpackChunkName: 'user-auth' */ 'Views/UserAuth/NewPassword/NewPassword.vue'); },
        meta: {
            requiresAuth: true,
            title: 'New Password',
        },
    },
    {
        path: '/sign-up',
        component: function () { return import(/* webpackChunkName: 'user-auth' */ 'Views/UserAuth/SignUp/SignUp.vue'); },
        meta: {
            requiresAuth: false,
            title: 'Sign Up',
        },
    },
    {
        path: '/sign-up/confirm-email/:email/:token',
        component: function () { return import(/* webpackChunkName: 'user-auth' */ 'Views/UserAuth/EmailConfirmation/EmailConfirmation.vue'); },
        meta: {
            requiresAuth: false,
            title: 'Confirm Email',
        },
    },
    {
        path: '/confirm-email',
        component: function () { return import(/* webpackChunkName: 'user-auth' */ 'Views/UserAuth/ConfirmEmail/ConfirmEmail.vue'); },
        meta: {
            requiresAuth: true,
            title: 'Confirm Email',
        },
    },
];
/* tslint:enable */



// WEBPACK FOOTER //
// ./~/ts-loader??ref--3!./src/js/Router/Routes/UserAuth.ts